/** @format */
import { css } from 'styled-components';

import { StyledFormattedConditionProps } from './types';

const boldStyles = ({ $boldConditionValue }: StyledFormattedConditionProps) => {
    if ($boldConditionValue) {
        return css`
            .condition-wrapper {
                font-weight: var(--typography-weight-bold);
                color: var(--colors-text-secondary);
            }
        `;
    }

    return css``;
};

export const styles = (props: StyledFormattedConditionProps) => css`
    ${boldStyles(props)}
`;
